"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = exports["default"] = void 0;
var _underscore = require("underscore");
var _types = require("../../actions/source/types");
var _types2 = require("../../actions/types");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var initialState = exports.initialState = {};
function attendeeCameraStatus() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var payload = action.payload,
    type = action.type;
  if (type === _types.CREATE_LOCAL_CAMERA) {
    var attendeeId = payload.attendeeId,
      isCameraOn = payload.isCameraOn;
    return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, attendeeId, isCameraOn));
  }
  if ([_types2.BROADCAST_SET_DESIRED_ATTENDEE_CAMERA_STATUS, _types2.BROADCAST_SET_ATTENDEE_CAMERA_STATUS].includes(type)) {
    var _attendeeId = payload.attendeeId,
      _isCameraOn = payload.isCameraOn;
    return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, _attendeeId, _isCameraOn));
  }

  // We use this to set all status when its a mixer
  if (_types2.BROADCAST_SET_ALL_ATTENDEES_CAMERA_STATUS === type) {
    var attendeesCameraStatus = payload.attendeesCameraStatus;
    return _objectSpread({}, attendeesCameraStatus);
  }
  if (action.type === _types2.BROADCAST_REMOVE_ATTENDEE_CAMERA) {
    var _attendeeId2 = payload.attendeeId;
    var newState = (0, _underscore.omit)(state, _attendeeId2);
    return _objectSpread({}, newState);
  }
  if ([_types2.BROADCAST_UPDATE_ATTENDEE_PRESENCE].includes(action.type)) {
    var _action$payload = action.payload,
      _attendeeId3 = _action$payload.attendeeId,
      present = _action$payload.present;
    if (!present) {
      var _newState = _objectSpread({}, state);
      delete _newState[_attendeeId3];
      return _newState;
    }
  }
  if ([_types2.BROADCAST_SET_MULTIPLE_DESIRED_ATTENDEE_CAMERA_STATUSES, _types2.BROADCAST_TOGGLE_MULTIPLE_AGORA_ATTENDEE_CAMERA_STATUSES].includes(type)) {
    return _objectSpread(_objectSpread({}, state), payload);
  }
  return state;
}
var _default = exports["default"] = attendeeCameraStatus;